import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-convenios',
    templateUrl: './convenios.component.html',
    styleUrls: ['./convenios.component.scss'],
    standalone: false
})

export class ConveniosComponent implements OnInit {
  selectedconvenioId: any;
  selectedNode = [];
  selectedGroup: string = '';
  selectedConvenio: string = '';
  onclear: number;
  isPanelShow: boolean;
  constructor() { }

  ngOnInit(): void {
  } 

  onClickEventEmiter(node: any): void {
    if (node) {
      this.selectedNode = node;
      this.selectedconvenioId = node.convenioId;
      this.isPanelShow = true;
    }
    else {
      this.selectedNode = null;
      this.selectedconvenioId = 0;
    }
  }
}
